var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUploadicon = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58852 19.168C1.60667 16.8661 1.86616 13.3934 4.16812 11.4115L6.66896 9.25841C7.12935 8.86204 7.82389 8.91393 8.22026 9.37432C8.61663 9.8347 8.56473 10.5292 8.10434 10.9256L5.6035 13.0787C4.22233 14.2678 4.06663 16.3515 5.25574 17.7326C6.44485 19.1138 8.52848 19.2695 9.90965 18.0803L12.4105 15.9272C12.8709 15.5309 13.5654 15.5828 13.9618 16.0431C14.3582 16.5035 14.3063 17.1981 13.8459 17.5944L11.345 19.7475C9.04307 21.7294 5.57036 21.4699 3.58852 19.168Z",
    fill: "#6C7066",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88737 7.93907C9.491 7.47869 9.5429 6.78414 10.0033 6.38777L12.5041 4.23467C14.8061 2.2528 18.2788 2.51227 20.2606 4.8142C22.2425 7.11613 21.983 10.5888 19.681 12.5707L17.1802 14.7238C16.7198 15.1202 16.0253 15.0683 15.6289 14.6079C15.2325 14.1475 15.2844 13.453 15.7448 13.0566L18.2457 10.9035C19.6268 9.71438 19.7825 7.63075 18.5934 6.24959C17.4043 4.86844 15.3207 4.71276 13.9395 5.90188L11.4387 8.05498C10.9783 8.45135 10.2837 8.39946 9.88737 7.93907Z",
    fill: "#6C7066",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59025 14.8609C8.19388 14.4006 8.24578 13.706 8.70617 13.3096L13.7078 9.00345C14.1682 8.60708 14.8628 8.65897 15.2591 9.11936C15.6555 9.57974 15.6036 10.2743 15.1432 10.6707L10.1416 14.9769C9.68116 15.3732 8.98662 15.3213 8.59025 14.8609Z",
    fill: "#6C7066",
    fillOpacity: 0.9
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadicon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/uploadicon.a343de78.svg";
export { ForwardRef as ReactComponent };